import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-task-edit',
  templateUrl: './project-task-edit.component.html',
  styleUrls: ['./project-task-edit.component.css']
})
export class ProjectTaskEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
